import XcolumnFunc from "@/pcomponents/common/xcolumn/xcolumn/xcolumn_func";
//const xColumnArr=getXcolumnJson();

const getXcolumnJson=()=>{
  let initData:any={
    table:"trade_fix",
    list_id:"trade_fix_list",
    x_column_list_arr:[
      {"key":"a_day_num","name":"일자","width":"100","is_show":"1"},
      {"key":"a_subject_detail","name":"분류명","width":"80","is_show":"1"},
      // {"key":"a_cust_par_id","name":"구분","width":"70","is_show":"1"},
      {"key":"a_cust_name","name":"거래처","width":"100","is_show":"1"},
      {"key":"a_trade_memo","name":"내용","width":"200","is_show":"1"},
      {"key":"a_money","name":"금액","width":"100","is_show":"1"},
      {"key":"a_pay_sort","name":"수단","width":"100","is_show":"1"},
      {"key":"a_is_fix","name":"고정여부","width":"100","is_show":"1"},
      // {"key":"row_view_trade","name":"지출","width":"100","is_show":"1"},
      {"key":"row_view_manage","name":"관리","width":"100","is_show":"1"},
      {"key":"row_view_order","name":"순번","width":"100","is_show":"1"},
      // {"key":"a_fix_term","name":"고정패턴","width":"100","is_show":"1"},
    ],
    list_opt_origin:{
      'now_page':1,
      'num_per_page':100,
      'order_id':'a_order_num, a_add_date DESC',
      'order_type':'',
      's_date_type':'',
      's_start_date':'',
      's_end_date':'',
      'sc':{},
      "is_add_idx_info":"1",
    },
    order_id_col_arr:[
      {"value":"","text":"없음"},
    ]
  };
  initData.pri_col_arr=["a_seq"];
  const xColumnArr:any=XcolumnFunc.getDefaultXcolumn(initData);
  xColumnArr.select_arr["a_day_num"]=[];
  for(let i=1;i<=30;i++){
    xColumnArr.select_arr["a_day_num"].push({value:i+"",text:i+""});
  }
  xColumnArr.select_arr["a_is_fix"]=[
    {"value":"1","text":"고정"},
  ];
  xColumnArr.select_arr["a_cust_par_id"]=[
    {"value":"user","text":"원생"},
    {"value":"trade_cust","text":"거래처"},
  ];
  xColumnArr.select_arr["a_pay_sort"]=[
    {"value":"money","text":"현금"},
    {"value":"card","text":"카드"},
    {"value":"etc","text":"기타"},
  ];

  return xColumnArr;
};

export default getXcolumnJson;